import React, { useState } from 'react';

function UpcomingBills({ token, bills, onUpdate }) {
  const [isAdding, setIsAdding] = useState(false);
  const [editingBill, setEditingBill] = useState(null);
  const [filter, setFilter] = useState('7'); // '7', '30', 'all'
  const [form, setForm] = useState({
    bill_name: '',
    amount: '',
    due_date: '',
    category: '', // New category field
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const method = editingBill ? 'PUT' : 'POST';
    const url = '/bills';
    const body = editingBill ? { ...form, id: editingBill.id } : form;

    try {
      const response = await fetch(url, {
        method,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify(body),
      });

      if (!response.ok) {
        throw new Error(`Failed to ${editingBill ? 'update' : 'add'} bill`);
      }

      setForm({
        bill_name: '',
        amount: '',
        due_date: '',
        category: '', // Reset category
      });
      setIsAdding(false);
      setEditingBill(null);
      onUpdate(); // Trigger a refetch in the parent component
    } catch (error) {
      console.error('Error saving bill:', error);
    }
  };

  const handleEdit = (bill) => {
    setEditingBill(bill);
    setForm({
      bill_name: bill.bill_name,
      amount: bill.amount,
      due_date: bill.due_date,
      category: bill.category || '', // Populate category
    });
    setIsAdding(true);
  };

  const handleDelete = async (id) => {
    try {
      const response = await fetch('/bills', {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({ id }),
      });

      if (!response.ok) {
        throw new Error('Failed to delete bill');
      }
      onUpdate(); // Trigger a refetch in the parent component
    } catch (error) {
      console.error('Error deleting bill:', error);
    }
  };

  const handleMarkAsPaid = async (bill) => {
    try {
      const response = await fetch('/bills', {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({ ...bill, is_paid: !bill.is_paid }),
      });

      if (!response.ok) {
        throw new Error('Failed to update bill status');
      }
      onUpdate();
    } catch (error) {
      console.error('Error marking bill as paid:', error);
    }
  };

  const filterBills = (billList) => {
    const now = new Date();
    const sevenDays = new Date();
    sevenDays.setDate(now.getDate() + 7);
    const thirtyDays = new Date();
    thirtyDays.setDate(now.getDate() + 30);

    return billList.filter(bill => {
      const dueDate = new Date(bill.due_date);
      if (filter === '7') {
        return dueDate >= now && dueDate <= sevenDays;
      }
      if (filter === '30') {
        return dueDate >= now && dueDate <= thirtyDays;
      }
      return true; // 'all' filter
    });
  };

  const isDueSoon = (dueDateStr) => {
    const dueDate = new Date(dueDateStr);
    const now = new Date();
    const sevenDays = new Date();
    sevenDays.setDate(now.getDate() + 7);
    return dueDate >= now && dueDate <= sevenDays;
  };

  return (
    <div>
      <h2>Upcoming Bills</h2>
      <button onClick={() => setIsAdding(!isAdding)}>
        {isAdding ? 'Cancel' : 'Add New Bill'}
      </button>

      {isAdding && (
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            name="bill_name"
            value={form.bill_name}
            onChange={handleChange}
            placeholder="Bill Name"
            required
          />
          <input
            type="number"
            name="amount"
            value={form.amount}
            onChange={handleChange}
            placeholder="Amount"
            required
          />
          <input
            type="date"
            name="due_date"
            value={form.due_date}
            onChange={handleChange}
            required
          />
          <select name="category" value={form.category} onChange={handleChange} required>
            <option value="">Select Category</option>
            <option value="Housing">Housing</option>
            <option value="Utilities">Utilities</option>
            <option value="Transportation">Transportation</option>
            <option value="Food">Food</option>
            <option value="Healthcare">Healthcare</option>
            <option value="Entertainment">Entertainment</option>
            <option value="Debt">Debt</option>
            <option value="Other">Other</option>
          </select>
          <button type="submit">{editingBill ? 'Update' : 'Add'} Bill</button>
        </form>
      )}

      <div>
        Filter:
        <select value={filter} onChange={(e) => setFilter(e.target.value)}>
          <option value="7">Next 7 days</option>
          <option value="30">Next 30 days</option>
          <option value="all">All</option>
        </select>
      </div>

      {bills.length > 0 ? (
        <ul>
          {filterBills(bills).map(b => (
            <li key={b.id} style={{ color: (isDueSoon(b.due_date) && !b.is_paid) ? 'red' : 'black' }}>
              {b.bill_name} - ${b.amount} due {b.due_date} {b.is_paid ? '(Paid)' : ''}
              {b.category && ` [${b.category}]`}
              <button onClick={() => handleEdit(b)}>Edit</button>
              <button onClick={() => handleDelete(b.id)}>Delete</button>
              <button onClick={() => handleMarkAsPaid(b)}>
                {b.is_paid ? 'Mark as Unpaid' : 'Mark as Paid'}
              </button>
            </li>
          ))}
        </ul>
      ) : (
        <p>No upcoming bills found.</p>
      )}
    </div>
  );
}

export default UpcomingBills;